import { render, staticRenderFns } from "./WhiteboardToolbar.vue?vue&type=template&id=1aea9386&"
import script from "./WhiteboardToolbar.vue?vue&type=script&lang=js&"
export * from "./WhiteboardToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports